import React, { useEffect, useState } from "react";
import moment from 'moment';
import { animalAssets } from '../../../services/constant';
import Collapse from "./Collapse";
import ModalView from "./modalView";
import InfoModal from "./modalInfo";
import { useGlobalContext } from '../../../services/GlobalContext';

import API_BASE_URL, { Providers } from '../../../services/Config';
import axios from 'axios';
import toast from 'react-hot-toast';
export default function InfoPage() {
    const { data, setloading } = useGlobalContext();
    const [show, setShow] = useState(false);
    const [serviceItems, setServiceItems] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    const [infoShow, setInfoShow] = useState(false);
    const [infoList, setInfoList] = useState({});
    const [isOpen, setIsOpen] = useState(false);

    const userData = JSON.parse(localStorage.getItem('userData'));
    const provider_id = userData['provider_id'];
    const token = localStorage.getItem('authToken');
    const network_id = localStorage.getItem('network_id');
    const handleInfo = async (item) => {

        await axios.get(`${API_BASE_URL()}/v3/applications/self/${Providers()}/networks/${network_id}/policies/${data.policies[0].id}/occurrences/${item.id}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then((res) => {

            setInfoList(res.data);
        }).catch((err) => {
            toast.error(err);

        })

        setInfoShow(true);
    }

    const fetchList = async () => {
        setloading(true);
        if (data.policies) {
            await axios.get(`${API_BASE_URL()}/v3/applications/self/${Providers()}/networks/${network_id}/policies/${data.policies[0].id}/occurrences?page_size=999&order_by=-created&state=validated`, {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                setItemsList(res.data.elements);
                setloading(false);
            }).catch((err) => {
                toast.error(err);
                setloading(false);
            })
        }
    }

    useEffect(() => {
        if (!show) {
            fetchList();
        }
    }, [data, show])
    return (
        <div className="stage_info">
            <div className="stage_title font-color">
                <img src={animalAssets.ic_title} className="title_icon" alt="" />
                <span className="font-18-500 title_title"> {data.distributor ? data.distributor.name : ''}</span>
                <span className="font-14-500 title_content1">Nº de Apólice </span>
                <span className="font-14-400 title_content2">{data.policies ? data.policies[0].code : ''}</span>
            </div>
            <div className="stage_collapse">
                <Collapse data={data} isOpen={isOpen} setIsOpen={setIsOpen} close></Collapse>
            </div>
            <div className="stage_consume">
                <div className="consume_header border-bottom flex flex-row">
                    <img src={animalAssets.ic_banner} className="btn_icon" alt="" />
                    <span className="font-14-400 self-center"> Consumos </span>
                    {itemsList ? (<button className="custom-button modal_btn" onClick={() => setShow(true)}> <img src={animalAssets.ic_show} style={{ width: '3.1rem', height: '3.1rem' }} alt="" /></button>) : <></>}
                </div>

                <div className={`consume_body overflow-y-scroll `} style={!isOpen ? { maxHeight: 'calc(100vh - 46rem)' } : { maxHeight: 'calc(100vh - 87rem)' }}>
                    {
                        itemsList ?
                            (
                                itemsList.map((item, index) => (
                                    <div key={index}>
                                        <section className="flex-column">
                                            <div className="flex-row custom-border-bottom " style={{ justifyContent: 'space-between' }}>
                                                <div className="flex-row">
                                                    <span className="font-16-600 mr-[1rem] font-center ml-[2rem] font-color"> Visita de </span>
                                                    <span className="font-16-400 font-center font-grey">{moment(item.occurrence_date).format('DD/MM/YYYY [às] HH:mm')} </span>
                                                </div>
                                                <button className="custom-button font-12-900 custom-text-underline font-color mr-2" onClick={() => handleInfo(item)}>ver mais</button>
                                            </div>
                                        </section>
                                    </div>
                                )
                                )
                            )
                            :
                            (
                                <div className="flex flex-col justify-center mt-[6rem]">
                                    <img src={animalAssets.ic_add} className="body_ic" alt="" />
                                    <span className="font-18-900 font-color self-center">Ainda não tem consumos registados!</span>
                                    <button className="body_btn btn-color font-15-900 hover:bg-[#29215B] hover:border-[#29215b]" onClick={() => setShow(true)}> REGISTAR CONSUMO </button>
                                </div>
                            )
                    }
                </div>
            </div>
            <ModalView show={show} setShow={setShow} serviceItems={serviceItems} setServiceItems={setServiceItems} />
            <InfoModal setInfoShow={setInfoShow} infoShow={infoShow} infoList={infoList} />
        </div >
    );
}